// src/components/UI/ThemeToggle.js
import React from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { DarkMode as DarkModeIcon, LightMode as LightModeIcon } from '@mui/icons-material';
import { useThemeContext } from '../../contexts/ThemeContext';

const ThemeToggle = ({ sx = {} }) => {
  const { themeMode, toggleTheme } = useThemeContext();
  const theme = useTheme();
  
  return (
    <Tooltip title={`Switch to ${themeMode === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton 
        onClick={toggleTheme} 
        color="inherit" 
        aria-label="toggle theme"
        sx={{ 
          ...sx,
          color: theme.palette.mode === 'dark' ? 'primary.light' : 'inherit',
          bgcolor: theme.palette.mode === 'dark' ? 'rgba(144, 202, 249, 0.08)' : 'background.default',
          '&:hover': {
            bgcolor: theme.palette.mode === 'dark' ? 'rgba(144, 202, 249, 0.12)' : 'action.hover'
          }
        }}
      >
        {themeMode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;